module.exports = __webpack_public_path__ + "static/media/usage_keychain.31826893.png";